import _objectSpread from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { openEditor } from '@pqina/pintura';
import { sub, unsub } from './events';

var PinturaEditorModal = /*#__PURE__*/function (_React$Component) {
  _inherits(PinturaEditorModal, _React$Component);

  var _super = _createSuper(PinturaEditorModal);

  function PinturaEditorModal(props) {
    var _this;

    _classCallCheck(this, PinturaEditorModal);

    _this = _super.call(this, props);
    _this.editor = undefined;
    return _this;
  }

  _createClass(PinturaEditorModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We'll wrap the module in a container so we can use the container as a CSS module target
      this.el = document.createElement('div');
      if (this.props.className) this.el.className = this.props.className;
      document.body.append(this.el); // Create editor and proxy events

      var props = _objectSpread({}, this.props);

      this.editor = openEditor(_objectSpread(_objectSpread({}, props), {}, {
        enableAutoDestroy: false
      }), this.el);
      sub(this, props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var props = _objectSpread({}, this.props);

      Object.assign(this.editor, props);
      sub(this, props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.editor) return;
      unsub(this);
      this.editor.destroy();
      this.editor = undefined;
      this.el.remove();
    }
  }, {
    key: "show",
    value: function show() {
      this.editor.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.editor.hide();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return PinturaEditorModal;
}(React.Component);

export default PinturaEditorModal;